import React from 'react';
import { KiteIcon } from '@kite/react-kite';
import './AccessServiceIcon.scss';

export interface IAccessServiceIconProps {}

const iconMap = {
  audio_description_and_full_audio: 'ki-audio-description',
  audio_description: 'ki-audio-description',
  closed_captions: 'ki-cc',
  sign_language: 'ki-sign-language',
};

const ariaLabelMap = {
  audio_description_and_full_audio: 'Audio Description + Full Audio',
  audio_description: 'Audio Description only',
  closed_captions: 'Closed Captioning',
  sign_language: 'Sign Language',
};

const AccessServiceIcon = ({ serviceType }) => {
  return (
    <KiteIcon
      className="access-service-icon"
      icon={iconMap[serviceType]}
      ariaLabel={ariaLabelMap[serviceType]}
      size="1.5rem"
    />
  );
};

export default AccessServiceIcon;
